import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';
import { useMemo } from 'react';
import { getScreens, system, getBreakpointMin, getBreakpointMax } from '@xstyled/system';
import { obj, string, func, cascade } from '@xstyled/util';

function useThemeScreens(theme) {
  return getScreens({
    theme: theme
  });
}

function useThemeMinValue(theme, key) {
  var screens = useThemeScreens(theme);
  var value = screens[key];
  return value === 0 ? null : value;
}

function useThemeMaxValue(theme, key) {
  var screens = useThemeScreens(theme);
  var breakPoint = screens[key];
  return breakPoint === 0 ? null : breakPoint - 0.02;
}

function useViewportWidth() {
  var _React$useState = React.useState(typeof window === "undefined" ? null : window.innerWidth),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1];

  React.useEffect(function () {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return width;
}

function useThemeBreakpoint(theme) {
  var screns = useThemeScreens(theme);
  var width = useViewportWidth();
  return React.useMemo(function () {
    return Object.keys(screns).reverse().find(function (screen) {
      return width !== null && width > screns[screen];
    }) || null;
  }, [screns, width]);
}

function useThemeUp(theme, key) {
  var value = useThemeMinValue(theme, key);
  var width = useViewportWidth();
  return width !== null && value !== null && width >= value;
}

function useThemeDown(theme, key) {
  var value = useThemeMaxValue(theme, key);
  var width = useViewportWidth();
  return width !== null && value !== null && width < value;
}

var join = function join() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join(".");
};

var toVarName = function toVarName(key) {
  return "--".concat(key.replace(/\./g, "-"));
};

var toVarValue = function toVarValue(key, value) {
  return "var(".concat(toVarName(key), ", ").concat(value, ")");
};

var toProp = function toProp(key, value) {
  return "".concat(key, ": ").concat(value, ";");
};

function toCustomPropertiesReferences(values, theme) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.keys(values);
  var parent = arguments.length > 3 ? arguments[3] : undefined;
  var next = Array.isArray(values) ? [] : {};

  for (var i in keys) {
    var key = keys[i];
    var value = values[key];
    var name = join(parent, key);

    if (obj(value)) {
      next[key] = toCustomPropertiesReferences(value, theme, Object.keys(value), name);
      continue;
    }

    if (string(value)) {
      next[key] = toVarValue(name, value);
      continue;
    }

    if (func(value)) {
      next[key] = toVarValue(name, cascade(value, {
        theme: theme
      }));
      continue;
    }
  }

  return next;
}

function toCustomPropertiesDeclarations(values, theme) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.keys(values);
  var parent = arguments.length > 3 ? arguments[3] : undefined;
  var state = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    value: ""
  };

  for (var i in keys) {
    var key = keys[i];
    var value = values[key];
    var name = join(parent, key);

    if (obj(value)) {
      toCustomPropertiesDeclarations(value, theme, Object.keys(value), name, state);
      continue;
    }

    if (string(value)) {
      state.value += toProp(toVarName(name), value);
      continue;
    }

    if (func(value)) {
      state.value += toProp(toVarName(name), cascade(value, {
        theme: theme
      }));
      continue;
    }
  }

  return state.value;
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var STORAGE_KEY = "xstyled-color-mode";

var isLocalStorageAvailable = typeof window !== "undefined" && function () {
  try {
    var key = "xstyled-test-key";
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (err) {
    return false;
  }
}();

var storage = isLocalStorageAvailable ? {
  get: function get() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
  set: function set(value) {
    window.localStorage.setItem(STORAGE_KEY, value);
  },
  clear: function clear() {
    return window.localStorage.removeItem(STORAGE_KEY);
  }
} : {
  get: function get() {
    return null;
  },
  set: function set() {},
  clear: function clear() {}
};
var COLOR_MODE_CLASS_PREFIX = "xstyled-color-mode-";

var getColorModeClassName = function getColorModeClassName(mode) {
  return "".concat(COLOR_MODE_CLASS_PREFIX).concat(mode);
};

var XSTYLED_COLORS_PREFIX = "xstyled-colors";
var SYSTEM_MODES = ["light", "dark"];

function getModeTheme(theme, mode) {
  return __spreadProps(__spreadValues({}, theme), {
    colors: __spreadValues(__spreadValues({}, theme.colors), theme.colors.modes[mode])
  });
}

var getMediaQuery = function getMediaQuery(query) {
  return "@media ".concat(query);
};

var getColorModeQuery = function getColorModeQuery(mode) {
  return "(prefers-color-scheme: ".concat(mode, ")");
};

function checkHasColorModes(theme) {
  return Boolean(theme && theme.colors && theme.colors.modes);
}

function checkHasCustomPropertiesEnabled(theme) {
  return Boolean(theme && (theme.useCustomProperties === void 0 || theme.useCustomProperties));
}

function checkHasMediaQueryEnabled(theme) {
  return Boolean(theme && (theme.useColorSchemeMediaQuery === void 0 || theme.useColorSchemeMediaQuery));
}

function getInitialColorModeName(theme) {
  return theme.initialColorModeName || "default";
}

function getDefaultColorModeName(theme) {
  return theme.defaultColorModeName || getInitialColorModeName(theme);
}

function getUsedColorKeys(modes) {
  var keys = [];

  for (var key in modes) {
    keys = [].concat(_toConsumableArray(keys), _toConsumableArray(Object.keys(modes[key])));
  }

  return keys;
}

function createColorStyles(theme) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$targetSelector = _ref.targetSelector,
      targetSelector = _ref$targetSelector === void 0 ? "body" : _ref$targetSelector;

  if (!checkHasColorModes(theme)) return null;

  var _a = theme.colors,
      modes = _a.modes,
      colors = __objRest(_a, ["modes"]);

  var colorKeys = getUsedColorKeys(modes);
  var styles = toCustomPropertiesDeclarations(colors, theme, colorKeys, XSTYLED_COLORS_PREFIX);

  function getModePropertiesDeclarations(mode) {
    var modeTheme = getModeTheme(theme, mode);

    var _a2 = modeTheme.colors,
        modes2 = _a2.modes,
        colors2 = __objRest(_a2, ["modes"]);

    return toCustomPropertiesDeclarations(__spreadValues(__spreadValues({}, colors2), modes2[mode]), modeTheme, colorKeys, XSTYLED_COLORS_PREFIX);
  }

  if (theme.useColorSchemeMediaQuery !== false) {
    SYSTEM_MODES.forEach(function (mode) {
      if (modes[mode]) {
        var mediaQuery = getMediaQuery(getColorModeQuery(mode));
        styles += "".concat(mediaQuery, "{").concat(getModePropertiesDeclarations(mode), "}");
      }
    });
  }

  var initialModeName = getInitialColorModeName(theme);
  [initialModeName].concat(_toConsumableArray(Object.keys(modes))).forEach(function (mode) {
    var key = "&.".concat(getColorModeClassName(mode));
    styles += "".concat(key, "{").concat(getModePropertiesDeclarations(mode), "}");
  });
  return "".concat(targetSelector, "{").concat(styles, "}");
}

function getSystemModeMql(mode) {
  if (typeof window === "undefined" || window.matchMedia === void 0) {
    return null;
  }

  var query = getColorModeQuery(mode);
  return window.matchMedia(query);
}

function useSystemMode(theme) {
  var configs = React.useMemo(function () {
    if (!checkHasMediaQueryEnabled(theme)) return [];
    return SYSTEM_MODES.map(function (mode) {
      if (!checkHasColorModes(theme)) return null;
      if (!theme.colors.modes[mode]) return null;
      var mql = getSystemModeMql(mode);
      return mql ? {
        mode: mode,
        mql: mql
      } : null;
    }).filter(Boolean);
  }, [theme]);

  var _React$useState3 = React.useState(function () {
    var config = configs.find(function (config2) {
      return config2.mql.matches;
    });
    return config ? config.mode : null;
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      systemMode = _React$useState4[0],
      setSystemMode = _React$useState4[1];

  React.useEffect(function () {
    var cleans = configs.map(function (_ref2) {
      var mode = _ref2.mode,
          mql = _ref2.mql;

      var handler = function handler(_ref3) {
        var matches = _ref3.matches;

        if (matches) {
          setSystemMode(mode);
        } else {
          setSystemMode(function (previousMode) {
            return previousMode === mode ? null : mode;
          });
        }
      };

      mql.addEventListener("change", handler);
      return function () {
        return mql.removeEventListener("change", handler);
      };
    });
    return function () {
      return cleans.forEach(function (clean) {
        return clean();
      });
    };
  });
  return systemMode;
}

var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;

function useColorModeState(theme) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      target = _ref4.target;

  var systemMode = useSystemMode(theme);
  var defaultColorMode = getDefaultColorModeName(theme);
  var initialColorMode = getInitialColorModeName(theme);

  var _React$useState5 = React.useState(function () {
    if (!checkHasColorModes(theme)) return null;
    return defaultColorMode;
  }),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      mode = _React$useState6[0],
      setMode = _React$useState6[1];

  var customPropertiesEnabled = checkHasCustomPropertiesEnabled(theme);
  var manuallySetMode = React.useCallback(function (value) {
    setMode(value || null);

    if (value) {
      storage.set(value);
    } else {
      storage.clear();
    }
  }, []);
  useIsomorphicLayoutEffect(function () {
    if (!checkHasColorModes(theme)) return;
    var storedMode = storage.get();
    var initialMode = storedMode || systemMode || defaultColorMode;

    if (mode !== initialMode) {
      setMode(storedMode || systemMode || defaultColorMode);
    }
  }, []);
  useIsomorphicLayoutEffect(function () {
    var storedMode = storage.get();
    if (storedMode) return;
    var targetMode = systemMode || defaultColorMode;
    if (targetMode === mode) return;
    setMode(targetMode);
  }, [mode, systemMode, defaultColorMode]);
  useIsomorphicLayoutEffect(function () {
    if (!mode) return void 0;
    if (!customPropertiesEnabled) return void 0;
    var stored = storage.get();
    var initial = initialColorMode !== mode;
    if (!stored && !initial) return void 0;
    var className = getColorModeClassName(mode);
    var usedTarget = target || document.body;
    usedTarget.classList.add(className);
    return function () {
      usedTarget.classList.remove(className);
    };
  }, [customPropertiesEnabled, target, mode, initialColorMode]);
  return [mode, manuallySetMode];
}

function useColorModeTheme(theme, mode) {
  var _React$useState7 = React.useState(mode),
      _React$useState8 = _slicedToArray(_React$useState7, 1),
      initialMode = _React$useState8[0];

  var customPropertiesTheme = React.useMemo(function () {
    if (!initialMode) return null;
    if (!checkHasCustomPropertiesEnabled(theme)) return null;
    if (!checkHasColorModes(theme)) return theme;

    var _a = theme.colors,
        modes = _a.modes,
        colors = __objRest(_a, ["modes"]);

    var colorKeys = getUsedColorKeys(modes);
    return __spreadProps(__spreadValues({}, theme), {
      colors: __spreadProps(__spreadValues(__spreadValues({}, colors), toCustomPropertiesReferences(colors, theme, colorKeys, XSTYLED_COLORS_PREFIX)), {
        modes: modes
      }),
      __rawColors: theme.colors
    });
  }, [initialMode, theme]);
  var swapModeTheme = React.useMemo(function () {
    if (!mode) return null;
    if (checkHasCustomPropertiesEnabled(theme)) return null;
    if (!checkHasColorModes(theme)) return theme;

    if (mode === getInitialColorModeName(theme)) {
      return __spreadProps(__spreadValues({}, theme), {
        __colorMode: mode
      });
    }

    return __spreadProps(__spreadValues({}, theme), {
      colors: __spreadValues(__spreadValues({}, theme.colors), theme.colors.modes[mode]),
      __colorMode: mode,
      __rawColors: theme.colors
    });
  }, [theme, mode]);
  return customPropertiesTheme || swapModeTheme;
}

var ColorModeContext = React.createContext(null);

function useColorMode() {
  var colorModeState = React.useContext(ColorModeContext);

  if (!colorModeState) {
    throw new Error("[useColorMode] requires the ColorModeProvider component");
  }

  return colorModeState;
}

function createColorModeProvider(_ref5) {
  var ThemeContext = _ref5.ThemeContext,
      ThemeProvider = _ref5.ThemeProvider,
      ColorModeStyle = _ref5.ColorModeStyle;

  function ColorModeProvider(_ref6) {
    var children = _ref6.children,
        target = _ref6.target,
        targetSelector = _ref6.targetSelector;
    var theme = React.useContext(ThemeContext);

    if (!theme) {
      throw new Error("[ColorModeProvider] requires ThemeProvider upper in the tree");
    }

    var colorState = useColorModeState(theme, {
      target: target
    });
    var colorModeTheme = useColorModeTheme(theme, colorState[0]);
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(ColorModeStyle, {
      targetSelector: targetSelector
    }), /* @__PURE__ */React.createElement(ThemeProvider, {
      theme: colorModeTheme
    }, /* @__PURE__ */React.createElement(ColorModeContext.Provider, {
      value: colorState
    }, children)));
  }

  return ColorModeProvider;
}

function getInitScript() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$target = _ref7.target,
      target = _ref7$target === void 0 ? "document.body" : _ref7$target;

  return "(function() { try {\n    var mode = localStorage.getItem('".concat(STORAGE_KEY, "');\n    if (mode) ").concat(target, ".classList.add('").concat(COLOR_MODE_CLASS_PREFIX, "' + mode);\n  } catch (e) {} })();");
}

function getColorModeInitScriptElement(options) {
  return /* @__PURE__ */React.createElement("script", {
    key: "xstyled-color-mode-init",
    dangerouslySetInnerHTML: {
      __html: getInitScript(options)
    }
  });
}

function getColorModeInitScriptTag(options) {
  return "<script>".concat(getInitScript(options), "</script>");
}

function createBox() {
  return ["&&{", system, "}"];
}

createBox.meta = system.meta;

var getMediaWidth = function getMediaWidth(getBreakpointBound) {
  return function (value) {
    return function (props) {
      var v = getBreakpointBound(getScreens(props), value);
      return v === null ? "0" : v || value;
    };
  };
};

var mediaGetters = {
  "min-width": getMediaWidth(getBreakpointMin),
  "max-width": getMediaWidth(getBreakpointMax)
};
var PROP_CHAR = "[-\\w]";
var VALUE_CHAR = "(?:\\\\[\\s\\S]|[^\\\\;{}])";
var PROP_PATT = "(".concat(PROP_CHAR, "+)(\\s*:\\s*)(?=\\S)(").concat(VALUE_CHAR, "*?)(\\s*!important)?(\\s*;)");
var MEDIA_CHAR = "[^{]";
var MEDIA_PATT = "(@media\\b\\s*)(?=\\S)(".concat(MEDIA_CHAR, "+?)(\\s*\\{)");
var MATCH_REGEXP = new RegExp("(?:".concat(PROP_PATT, "|").concat(MEDIA_PATT, ")"), "g");
var QUERY_REGEXP = new RegExp("(\\(\\s*)(".concat(PROP_CHAR, "+)(\\s*:\\s*)([^\\)]*?)(\\s*\\))"), "g");

var mediaTransform = function mediaTransform(rawValue) {
  var matches;
  var lastIndex = 0;
  var values = [];

  var _loop = function _loop() {
    var _matches = matches,
        _matches2 = _slicedToArray(_matches, 6),
        open = _matches2[1],
        prop = _matches2[2],
        colon = _matches2[3],
        value = _matches2[4],
        close = _matches2[5];

    var getter = mediaGetters[prop];

    if (getter) {
      values.push(rawValue.slice(lastIndex, matches.index));
      values.push(function (p) {
        return "".concat(open).concat(prop).concat(colon).concat(getter(value)(p)).concat(close);
      });
      lastIndex = matches.index + matches[0].length;
    }
  };

  while (matches = QUERY_REGEXP.exec(rawValue)) {
    _loop();
  }

  values.push(rawValue.slice(lastIndex, rawValue.length));
  return values;
};

var createTransform = function createTransform(generator) {
  return function (rawValue) {
    if (typeof rawValue !== "string") return rawValue;
    var matches;
    var lastIndex = 0;
    var values = [];

    var _loop2 = function _loop2() {
      var _matches3 = matches,
          _matches4 = _slicedToArray(_matches3, 9),
          prop = _matches4[1],
          colon = _matches4[2],
          value = _matches4[3],
          imp = _matches4[4],
          semi = _matches4[5],
          media = _matches4[6],
          query = _matches4[7],
          brace = _matches4[8];

      if (media) {
        values.push(rawValue.slice(lastIndex, matches.index));
        values.push(media);
        mediaTransform(query).forEach(function (v) {
          return values.push(v);
        });
        values.push(brace);
        lastIndex = matches.index + matches[0].length;
      } else {
        var getter = generator.meta.cssGetters[prop];

        if (getter) {
          values.push(rawValue.slice(lastIndex, matches.index));
          values.push(function (p) {
            return "".concat(prop).concat(colon).concat(getter(value)(p)).concat(imp || "").concat(semi);
          });
          lastIndex = matches.index + matches[0].length;
        }
      }
    };

    while (matches = MATCH_REGEXP.exec(rawValue)) {
      _loop2();
    }

    values.push(rawValue.slice(lastIndex, rawValue.length));
    return values;
  };
};

var createUseGetter = function createUseGetter(getter, useTheme) {
  return function (value, defaultValue) {
    var theme = useTheme();
    return useMemo(function () {
      return getter(value, defaultValue)({
        theme: theme
      });
    }, [value, defaultValue, theme]);
  };
};

export { ColorModeContext, createBox, createColorModeProvider, createColorStyles, createTransform, createUseGetter, getColorModeInitScriptElement, getColorModeInitScriptTag, useColorMode, useColorModeState, useColorModeTheme, useThemeBreakpoint, useThemeDown, useThemeScreens, useThemeUp, useViewportWidth };